export default "__VITE_ASSET___47jH_mz__"